/* sugar:assets/order-tracking.js@2.0.0 */
/**
 * Order Tracking section — 17track handoff, tab switching and copy-to-clipboard.
 *
 * One controller for every [data-order-tracking] root on the page, so the section
 * ships no per-instance inline script.
 */

(function () {
  function rootFor(sectionId) {
    return document.querySelector('[data-order-tracking][data-section-id="' + sectionId + '"]');
  }

  /**
   * Track a package using 17track.
   * @param {string} sectionId - The section ID
   * @param {string} trackingNum - The tracking number
   */
  window.trackWith17Track = function (sectionId, trackingNum) {
    const section = rootFor(sectionId);
    if (!section) return;

    const method = section.dataset.trackingMethod || 'embed';
    const widgetHeight = parseInt(section.dataset.widgetHeight, 10) || 560;
    const lang = section.dataset.lang || 'en';
    const trackingUrl = 'https://t.17track.net/' + encodeURIComponent(lang) + '#nums=' + encodeURIComponent(trackingNum);

    function openTrackingInNewTab() {
      const trackingWindow = window.open(trackingUrl, '_blank', 'noopener,noreferrer');
      if (trackingWindow) {
        trackingWindow.opener = null;
      }
    }

    if (method === 'new_tab') {
      openTrackingInNewTab();
      return;
    }

    // Embed method - use section-specific 17track container ID
    const containerId = section.dataset.widgetContainerId || 'YQContainer-' + sectionId;
    const container = document.getElementById(containerId);
    if (!container) {
      // Fallback to new tab if container doesn't exist
      openTrackingInNewTab();
      return;
    }

    // Show loading state
    const loading = document.createElement('p');
    loading.className = 'sugar-order-tracking__loading';
    loading.textContent = section.dataset.loadingText || '';
    container.innerHTML = '';
    container.appendChild(loading);

    // Wait for 17track script and initialize widget
    var attempts = 0;
    var maxAttempts = 50;

    function initWidget() {
      attempts++;
      if (typeof YQV5 !== 'undefined') {
        container.innerHTML = '';
        YQV5.trackSingle({
          YQ_ContainerId: containerId,
          YQ_Height: widgetHeight,
          YQ_Fc: '0',
          YQ_Lang: lang,
          YQ_Num: trackingNum
        });
      } else if (attempts < maxAttempts) {
        setTimeout(initWidget, 100);
      } else {
        // Fallback: open in new tab if script fails to load
        openTrackingInNewTab();
        container.innerHTML = '';
      }
    }

    initWidget();
  };

  function setTab(root, index) {
    root.querySelectorAll('[data-ot-tab]').forEach(function (tab) {
      var on = Number(tab.dataset.otTab) === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-ot-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', Number(panel.dataset.otPanel) === index);
    });
  }

  function init(root) {
    if (!root || root._sugarOt) return;
    root._sugarOt = true;

    var sectionId = root.dataset.sectionId;
    var input = root.querySelector('[data-ot-input]');
    var submit = root.querySelector('[data-ot-submit]');
    var form = root.querySelector('[data-ot-form]');

    function syncSubmit() {
      if (submit && input) submit.disabled = !input.value.trim();
    }

    function track(number) {
      if (!number) return;
      window.trackWith17Track(sectionId, number);
    }

    if (input) input.addEventListener('input', syncSubmit);
    syncSubmit();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        track(input ? input.value.trim() : '');
      });
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ot-tab]');
      if (tab && root.contains(tab)) {
        setTab(root, Number(tab.dataset.otTab));
        return;
      }

      // Tracking a number from the order list hands it to the search panel.
      var trackBtn = e.target.closest('[data-ot-track]');
      if (trackBtn && root.contains(trackBtn)) {
        var number = trackBtn.dataset.otTrack;
        setTab(root, 0);
        if (input) {
          input.value = number;
          syncSubmit();
        }
        requestAnimationFrame(function () {
          track(number);
        });
        return;
      }

      var copyBtn = e.target.closest('[data-ot-copy]');
      if (!copyBtn || !root.contains(copyBtn)) return;

      navigator.clipboard.writeText(copyBtn.dataset.otCopy).then(function () {
        // The tick replaces the clipboard for two seconds; the swap is CSS.
        copyBtn.classList.add('is-copied');
        clearTimeout(copyBtn._otTimer);
        copyBtn._otTimer = setTimeout(function () {
          copyBtn.classList.remove('is-copied');
        }, 2000);
      }).catch(function () {});
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-order-tracking]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  // Shopify editor events
  function reinit(event) {
    var root = event.target.querySelector('[data-order-tracking]');
    if (!root) return;
    initAll(event.target);
    if (window.SugarInteractive) window.SugarInteractive.init(root);
  }

  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('shopify:section:select', reinit);
})();
